import React from "react";
import { NavLink } from "react-router-dom";

const BottonMenu = ({ w3_close }) => {
  return (
    <div className="rk_game_dock">
      {/* ================= HOME ================= */}
      <NavLink
        exact
        to="/landing"
        activeClassName="rk_dock_active"
        className="rk_dock_item"
      >
        <div className="rk_dock_icon_wrap">
          <img src="./home.png" className="rk_dock_icon" alt="Home" />
        </div>

        <span className="rk_dock_label">HOME</span>

        <span className="rk_dock_active_line"></span>
      </NavLink>

      {/* ================= WALLET ================= */}
      <NavLink
        exact
        to="/wallet"
        activeClassName="rk_dock_active"
        className="rk_dock_item"
      >
        <div className="rk_dock_icon_wrap">
          <img src="./wallet.png" className="rk_dock_icon" alt="Wallet" />
        </div>

        <span className="rk_dock_label">WALLET</span>

        <span className="rk_dock_active_line"></span>
      </NavLink>

      {/* ================= PLAY ================= */}
      <NavLink
        exact
        to="/play"
        activeClassName="rk_dock_active"
        className="rk_dock_item rk_play_item"
      >
        <div className="rk_play_outer">
          <div className="rk_play_ring rk_play_ring_1"></div>
          <div className="rk_play_ring rk_play_ring_2"></div>

          <div className="rk_play_button">
            <img src="./play-ludo.png" className="rk_play_icon" alt="Play" />
          </div>
        </div>

        {/* <span className="rk_dock_label">PLAY</span> */}
      </NavLink>

      {/* ================= SUPPORT ================= */}
      <NavLink
        exact
        to="/support"
        activeClassName="rk_dock_active"
        className="rk_dock_item"
      >
        <div className="rk_dock_icon_wrap">
          <img
            src="./support-icon.png"
            className="rk_dock_icon"
            alt="Support"
          />
        </div>

        <span className="rk_dock_label">SUPPORT</span>

        <span className="rk_dock_active_line"></span>
      </NavLink>

      {/* ================= PROFILE ================= */}
      <NavLink
        exact
        to="/Profile"
        activeClassName="rk_dock_active"
        className="rk_dock_item"
      >
        <div className="rk_dock_icon_wrap">
          <img src="./profile.png" className="rk_dock_icon" alt="Profile" />
        </div>

        <span className="rk_dock_label">PROFILE</span>

        <span className="rk_dock_active_line"></span>
      </NavLink>
    </div>
  );
};

export default BottonMenu;
